<div class="form-wrapper">
  <div class="form-content size size1of1">
    <div [formGroup]="form" class="form-block">
      <!-- Name -->
      <div class="form-row">
        <mat-form-field floatLabel="always" class="custom-mat-form-field size size1of1">
          <mat-label>Charge Name</mat-label>
          <input matInput formControlName="name" required placeholder="Describe what you charge your customers for.">
          <mat-error><error-messages [control]="form.get('name')"></error-messages></mat-error>
        </mat-form-field>
      </div>
      <!-- Category -->
      <div class="form-row">
        <mat-form-field class="custom-mat-form-field field-price-model size size1of1">
          <mat-label>Category</mat-label>
          <mat-select required (selectionChange)="onChangeCategory($event.value)" formControlName="category" disableOptionCentering="true" panelClass="custom-mat-select-panel" class="custom-mat-select" [disabled]="_data.isNewSubscription">
            <mat-option *ngFor="let category of collectionOfProductRatePlanChargesCategory" [value]="category.value" class="custom-mat-option">{{ category.label }}</mat-option>
          </mat-select>
          <mat-error><error-messages [control]="form.get('category')"></error-messages></mat-error>
        </mat-form-field>
      </div>
      <!-- Dimensions info -->
      <div [style.display]="selectedCategory === _categoryValues.physical ? 'block' : 'none'" class="form-row row-flex-wrap">
        <mat-form-field floatLabel="always" class="custom-mat-form-field size size1of1 md-size1of4">
          <mat-label>Weight ({{weightMeasurement}})</mat-label>
          <input matInput type="text" formControlName="weight" required placeholder="0.00" [cleave]="cleaveNumDecimalOptions">
          <mat-error><error-messages [control]="form.get('weight')"></error-messages></mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="custom-mat-form-field size size1of1 md-size1of4">
          <mat-label>Width ({{lengthMeasurement}})</mat-label>
          <input matInput type="text" formControlName="width" placeholder="0.00" [cleave]="cleaveNumDecimalOptions">
          <mat-error><error-messages [control]="form.get('width')"></error-messages></mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="custom-mat-form-field size size1of1 md-size1of4">
          <mat-label>Height ({{lengthMeasurement}})</mat-label>
          <input matInput type="text" formControlName="height" placeholder="0.00" [cleave]="cleaveNumDecimalOptions">
          <mat-error><error-messages [control]="form.get('height')"></error-messages></mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="custom-mat-form-field size size1of1 md-size1of4">
          <mat-label>Depth ({{lengthMeasurement}})</mat-label>
          <input matInput type="text" formControlName="depth" placeholder="0.00" [cleave]="cleaveNumDecimalOptions">
          <mat-error><error-messages [control]="form.get('depth')"></error-messages></mat-error>
        </mat-form-field>
      </div>
      <!-- Shipping -->
      <div class="form-row">
        <mat-checkbox formControlName="isFreeShipping" color="primary" disableRipple="true" class="custom-mat-checkbox rounded checkbox-simple-line">
          <span class="typo semi-condensed fw400">Free Shipping</span>
        </mat-checkbox>
      </div>
    </div>
  </div>
</div>
